import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { MandatoryWarningIcon } from './MandatoryWarningIcon';
import { EditableCellProps } from './types';

export const EditableCell: React.FC<EditableCellProps> = ({
  children,
  showWarning,
  isEdited,
  originalValue,
  fullWidth = false,
  warningType,
}) => {
  const cellContent = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        ...(fullWidth && { width: '100%' }),
      }}
    >
      {showWarning && <MandatoryWarningIcon warningType={warningType} />}
      {children}
    </Box>
  );

  if (isEdited) {
    return (
      <Tooltip
        title={`Original: ${originalValue || '(empty)'}`}
        arrow
        placement="top"
      >
        {cellContent}
      </Tooltip>
    );
  }

  return cellContent;
};
